import { render, staticRenderFns } from "./Icons.vue?vue&type=template&id=3a39f1e7&scoped=true"
import script from "./Icons.vue?vue&type=script&lang=js"
export * from "./Icons.vue?vue&type=script&lang=js"
import style0 from "./Icons.vue?vue&type=style&index=0&id=3a39f1e7&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a39f1e7",
  null
  
)

export default component.exports